import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable, startWith, takeUntil } from 'rxjs';
import { IMember } from '../../models/member';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-member-length-icon',
  templateUrl: './member-length-icon.component.html',
  styleUrls: ['./member-length-icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MemberLengthIconComponent extends BaseComponent implements OnInit {
  @Input() isOpen = false;
  @Input() members: IMember[] = [];
  dir: 'rtl' | 'ltr' = 'rtl';
  lang = 'en';
  constructor(private translate: TranslateService) {
    super();
  }
  ngOnInit(): void {
    (this.translate.onLangChange as Observable<LangChangeEvent>)
      .pipe(startWith({ lang: this.translate.currentLang }), takeUntil(this.destroy$))
      .subscribe((res) => {
        this.dir = res.lang == 'ar' ? 'rtl' : 'ltr';
      });
  }
}
